import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { makeStyles } from '@material-ui/core';
import { MDSModal } from '@marqvision/mds-v2';
import { MDSButton } from '@marqvision/mds/core';
import { useUserInfoQuery } from '~/apis/auth';
import { AuthProtocolsGetUserInfoResponse, SettingsProtocolsGetProfileResponse } from '~/swagger/data-contracts';
import { useGetProfileQuery } from '~/apis/settings';
import { getLangCode } from '../@utils';
import { UNAUTHORIZED_SALES_CLIENT_IDS } from '../@constants';
import { usePmmReleaseNoteDialog } from './@hooks';
import { ContentKR } from './ContentKR';
import { ContentEN } from './ContentEN';

const useStyles = makeStyles({
  layout: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  space: {
    width: '100%',
    height: '16px',
  },
  paragraph: {
    // padding: '8px 0',
  },
  link: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  item: {
    display: 'flex',
    '& > p': {
      marginLeft: '8px',
      width: '24px',
    },
    '& > p:last-child': {
      flex: 1,
      marginLeft: '-12px',
    },
  },
  video: {
    borderRadius: '8px',
    backgroundColor: '#000',
    width: '640px',
    height: '391px',
    overflow: 'hidden',
  },
  actions: {
    padding: '16px 20px',
    display: 'flex',
    justifyContent: 'space-between',
  },
});

type Props = {
  userInfo: AuthProtocolsGetUserInfoResponse;
  userProfile: SettingsProtocolsGetProfileResponse;
};
const PmmDialogContent = (props: Props) => {
  const { userInfo, userProfile } = props;
  const { isOpen, onDoNotShowAgainClick, onGotItClick } = usePmmReleaseNoteDialog(userInfo);
  const classes = useStyles();

  const langCode = getLangCode(userInfo.language);

  const isUnauthorizedSalesClient = UNAUTHORIZED_SALES_CLIENT_IDS.includes(userInfo.client_id);

  return (
    <MDSModal.Wrapper isOpen={isOpen} width="680px">
      <MDSModal.Content>
        {/* unauthorized sales client는 무조건 한국어 버전을 보여준다 */}
        {isUnauthorizedSalesClient || langCode === 'KO' ? (
          <ContentKR userInfo={userInfo} userProfile={userProfile} />
        ) : (
          <ContentEN userProfile={userProfile} />
        )}
      </MDSModal.Content>
      <div className={classes.actions}>
        <MDSButton variant="outline" color="blue" size="medium" onClick={onDoNotShowAgainClick}>
          Do not show this again
        </MDSButton>
        <MDSButton variant="fill" color="blue" size="medium" onClick={onGotItClick}>
          Got it
        </MDSButton>
      </div>
    </MDSModal.Wrapper>
  );
};

// todo-@jamie: [PROD-12158] Prop을 어떻게 뺄지 생각하기
export const PmmDialog = () => {
  const { data: userInfo } = useUserInfoQuery();
  const { data: userProfile } = useGetProfileQuery({
    enabled: !!userInfo,
  });
  const isPmmOn = useFeatureIsOn('brand-client-product-marketing-material');
  if (!isPmmOn) return null;

  return isPmmOn && userInfo && userProfile && <PmmDialogContent userInfo={userInfo} userProfile={userProfile} />;
};
